import * as React from 'react';
import { useDispatch } from 'react-redux';

import { newbuildingChatOpenToggle } from '../../state/newbuildingConsultant';
import { NewbuildingConsultBanner } from './NewbuildingConsultBanner';

export function NewbuildingConsultBannerConatiner() {
  const dispatch = useDispatch();
  const open = React.useCallback(() => dispatch(newbuildingChatOpenToggle(true)), []);

  return <NewbuildingConsultBanner onChatClick={open} />;
}
